
import { CreateElement } from "vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import { NormalizedScopedSlot } from "vue/types/vnode";

@Component({})

export default class FuncRenderer extends Vue {
    @Prop() node: NormalizedScopedSlot | undefined;
    @Prop() row: Record<string, any>;
    @Prop() index: number;

    render(h: CreateElement) {
        const forRender = this.node?.({ row: this.row, index: this.index });
        if(Array.isArray(forRender)) {
            return h('div', forRender.map(item => item))
        }
        else {
            return forRender
        }
    }
}

